/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {overtimeReportByTimecardForEmployee} from '../api'

export const useMutationOvertimeReportByTimecardForEmployee = createReactQueryMutationHook('overtimeReportByTimecardForEmployee', overtimeReportByTimecardForEmployee)
